export default function AuthSecondaryButton({ children, className = '', type = 'button', ...props }) {
  return (
    <button
      type={type}
      className={`flex h-[53px] w-full items-center justify-center rounded-[10px] border border-solid border-gray02 bg-[rgba(255,255,255,0.5)] font-['Pretendard'] text-[16px] font-bold text-gray04 outline-none ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
